import React from 'react';

import { withContent } from 'components/Content';
import RichText from 'components/RichText';

import styles from './halfsy.scss';

const CONTENT_KEYS = {
  features: 'Features',
};

const Halfsy = ({ content }) => {
  const { features } = content;

  return (
    <div className={styles.halfsy}>
      {features.fields.features.map((feature) => {
        const { content, backgroundImage } = feature.fields;
        return (
          <div key={feature.sys.id} className={styles.feature}>
            <img
              className={styles.left}
              src={`${backgroundImage.fields.file.url}?fm=webp`}
              alt={backgroundImage.fields.title}
              aria-hidden="true"
            />
            <div className={styles.right}>
              <RichText richText={content} styles={styles} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default withContent(CONTENT_KEYS)(Halfsy);
